import { CommonAPI } from "../CommonAPI/CommonAPI";

export const MetalMasterData = async (Mode, metalType, PurchaseGold, SaleP) => {
  let response;
  try {
    // const token = "LGN103D12R6A17HG4CAI" ?? "";
    // const DeviceToken = "U015UW9PV4JY9S9A" ?? "";

    const token =
      window.location.hostname === "localhost" ||
      window.location.hostname === "nzen"
        ? "LGN103D12R6A17HG4CAI"
        : sessionStorage.getItem("token") ?? "";
    const DeviceToken =
      window.location.hostname === "localhost" ||
      window.location.hostname === "nzen"
        ? "U015UW9PV4JY9S9A"
        : sessionStorage.getItem("device_token") ?? "";
    const SV =
      window.location.hostname === "localhost" ||
      window.location.hostname === "nzen"
        ? "0"
        : sessionStorage.getItem("SV") ?? "";

    const combinedValue = JSON.stringify({
      Token: `${token}` ?? "",
      DeviceToken: DeviceToken ?? "",
      Mode: `${Mode}` ?? "",
      MetalTypeName: `${metalType}` ?? "",
      PurchasePrice: `${PurchaseGold}` ?? "",
      SalePrice: `${SaleP}` ?? "",
    });

    const body = {
      Token: `${token}`,
      DeviceToken: DeviceToken,
      SV: SV,
      // SV: "0",
      ReqData: combinedValue,
    };

    response = await CommonAPI(body);
  } catch (error) {
    console.error("Error:", error);
  }
  return response;
};
